export const FILTER_COLAPSED_ROW_HEIGHT = 42;
